import CustomValuesPayroll from "components/Employees/CustomValuesPayroll";
import GovernmentLoans from "components/Employees/GovernmentLoans";
import LeaveBalances from "components/Employees/LeaveBalances";
import moment from "moment/moment";
import React, { Component } from "react"
import { Grid, Row, Col, Button } from "react-bootstrap"
import { fetchEmployeeRequest } from "../../api/employee"
import { getFullName } from "../../helpers/functions/employee"
import { formatPrice } from "../../helpers/functions/pricing"

class EmployeeDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            resource: {
                _id: null,
                company: null,
                firstName: null,
                middleName: null,
                lastName: null,
                employeeType: null,
                employeeNumber: null,
                dateHired: null,
                dateDischarged: null,
                birthdayDate: null,
                employmentStatus: null,
                dateRegularized: null,
                tinClassification: null,
                tinNumber: null,
                sss: null,
                sssNumber: null,
                phicNumber: null,
                hdmfNumber: null,
                ecolaNumber: null,
                payrollClassification: null,
                payLevel: null,
                superior: null,
                department: null,
                position: null,
                status: null,
                allowancesPerDiem: null,
                allowancesGasoline: null,
                allowancesMeal: null,
                allowancesTelephone: null,
                allowancesOperational: null,
                allowancesTransportation: null,
                allowancesHousing: null,
                allowancesOthers: null,
            },
            activeTab: "personalInformation",
            loading: true
        }
    }

    componentDidMount() {
        const { match } = this.props;
        if(match.params.id) {
            this.fetchEmployee(match.params.id)
        }
    }

    fetchEmployee = (id) => {
        fetchEmployeeRequest(id, result => this.setState({resource: result}), error => console.log(error))
        this.setState({loading: false})
    }

    goToEmployeeList = () => {
        this.props.history.push('/employees/list')
    }

    goToEmployeeEditForm = (id) => {
        this.props.history.push('/employees/edit/' + id)
    }
    
    changeActiveTab = (e, tabState, tadName) => {
        e.preventDefault();
        this.setState({
          [tabState]: tadName,
        });
      };

    render() {

        const { 
            _id,
            company, 
            firstName, 
            middleName, 
            lastName, 
            employeeType, 
            employeeNumber, 
            dateHired, 
            dateDischarged, 
            birthdayDate, 
            employmentStatus, 
            dateRegularized, 
            tinClassification, 
            tinNumber, 
            sssNumber, 
            phicNumber, 
            hdmfNumber, 
            ecolaNumber, 
            payrollClassification, 
            payLevel, 
            superior, 
            department, 
            position,
            status,
            allowancesPerDiem,
            allowancesGasoline,
            allowancesMeal,
            allowancesTelephone,
            allowancesOperational,
            allowancesTransportation,
            allowancesHousing,
            allowancesOthers,
        } = this.state.resource;

        const  {
            activeTab
        } = this.state

        const allowances = [
            { label: "Per Diem", value: allowancesPerDiem },
            { label: "Gasoline", value: allowancesGasoline },
            { label: "Meal (per day)", value: allowancesMeal },
            { label: "Telephone", value: allowancesTelephone },
            { label: "Operational Expenses", value: allowancesOperational },
            { label: "Transportation", value: allowancesTransportation },
            { label: "Housing", value: allowancesHousing },
            { label: "Others", value: allowancesOthers },
        ];

        const tabs = [
            {
              title: "Personal Information",
              type: "personalInformation"
            },
            {
              title: "Custom values for Payroll",
              type: "customPayroll"
            },
            {
                title: "Government Loans",
                type: "governmentLoans"
            },
            {
                title: "Leave Balances",
                type: "leaveBalances"
            }
          ] 

        return (
        <div className="content">
            <Grid fluid>
            <div className="form-header">
                <h3 className="text-secondary font-weight-bold">
                    Employee Details
                </h3>
                <Button className="btn btn-primary top-btn" onClick={this.goToEmployeeList}>Back to list</Button> 
                <div className="tabs-nav" style={{marginBottom: "20px"}}>
                  {tabs.map((tab) => {
                        return (
                            <button
                              data-toggle="tab"
                              href="#pablo"
                              className={
                                this.state.activeTab === tab.type
                                  ? "tab-button active"
                                  : "tab-button"
                              }
                              onClick={(e) =>
                                this.changeActiveTab(
                                  e,
                                  "activeTab",
                                  tab.type
                                )
                              }
                            >
                              {tab.title}
                            </button>
                        )
                      })}
                </div>
            </div>
            <Row style={activeTab === "personalInformation" ? null : {display: "none"}}>
                <Col md={12}>
                <div className="typo-line">
                    <div>
                    <p className="category">Employee ID</p>
                    {_id || 'N/A'}
                    </div>
                </div>
                <div className="typo-line">
                    <div>
                    <p className="category">Company</p>
                    {company ? company.companyName : 'N/A'}
                    </div>
                </div>
                <div className="typo-line">
                    <div>
                    <p className="category">First Name</p>
                    {firstName || 'N/A'}
                    </div>
                </div>
                <div className="typo-line">
                    <div>
                    <p className="category">Middle Name</p>
                    {middleName || 'N/A'}
                    </div>
                </div>
                <div className="typo-line">
                    <div>
                    <p className="category">Last Name</p>
                    {lastName || 'N/A'}
                    </div>
                </div>
                <div className="typo-line">
                    <div>
                    <p className="category">Employee Type</p>
                    {employeeType ? employeeType.employeeTypeName : 'N/A'}
                    </div>
                </div>
                <div className="typo-line">
                    <div>
                    <p className="category">Employee Number</p>
                    {employeeNumber || 'N/A'}
                    </div>
                </div>
                <div className="typo-line">
                    <div>
                    <p className="category">Date Hired</p>
                    {dateHired ? moment(dateHired).format('MM/DD/YYYY') : 'N/A'}
                    </div>
                </div>
                <div className="typo-line">
                    <div>
                    <p className="category">Date Discharged</p>
                    {dateDischarged ? moment(dateDischarged).format('MM/DD/YYYY') : 'N/A'}
                    </div>
                </div>
                <div className="typo-line">
                    <div>
                    <p className="category">Birthday</p>
                    {birthdayDate ? moment(birthdayDate).format('MM/DD/YYYY') : 'N/A'}
                    </div>
                </div>
                <div className="typo-line">
                    <div>
                    <p className="category">Employment Status</p>
                    {employmentStatus || 'N/A'}
                    </div>
                </div>
                <div className="typo-line">
                    <div>
                    <p className="category">Date Regularized</p>
                    {dateRegularized ? moment(dateRegularized).format('MM/DD/YYYY') : 'N/A'}
                    </div>
                </div>
                <div className="typo-line">
                    <div>
                    <p className="category">TIN Classification</p>
                    {tinClassification || 'N/A'}
                    </div>
                </div>
                <div className="typo-line">
                    <div>
                    <p className="category">TIN Number</p>
                    {tinNumber || 'N/A'}
                    </div>
                </div>
                <div className="typo-line">
                    <div>
                    <p className="category">SSS Number</p>
                    {sssNumber || 'N/A'}
                    </div>
                </div>
                <div className="typo-line">
                    <div>
                    <p className="category">PHIC Number</p>
                    {phicNumber || 'N/A'}
                    </div>
                </div>
                <div className="typo-line">
                    <div>
                    <p className="category">HDMF Number</p>
                    {hdmfNumber || 'N/A'}
                    </div>
                </div>
                <div className="typo-line">
                    <div>
                    <p className="category">ECOLA Number</p>
                    {ecolaNumber || 'N/A'}
                    </div>
                </div>
                <div className="typo-line">
                    <div>
                    <p className="category">Payroll Classification</p>
                    {payrollClassification || 'N/A'}
                    </div>
                </div>
                <div className="typo-line">
                    <div>
                    <p className="category">Pay Level</p>
                    {payLevel ? payLevel.payLevelName : 'N/A'}
                    </div>
                </div>
                <div className="typo-line">
                    <div>
                    <p className="category">Superior</p>
                    {superior ? getFullName(superior) : 'N/A'}
                    </div>
                </div>
                <div className="typo-line">
                    <div>
                    <p className="category">Department</p>
                    {department ? department.departmentName : 'N/A'}
                    </div>
                </div>
                <div className="typo-line">
                    <div>
                    <p className="category">Position</p>
                    {position ? position.positionName : 'N/A'}
                    </div>
                </div>
                <h4>Allowances</h4>
                {allowances.map((allowance) => (
                    <div className="typo-line" key={allowance.label}>
                        <div>
                        <p className="category">{allowance.label}</p>
                        {allowance.value === null || allowance.value === undefined || allowance.value === ''
                            ? 'N/A'
                            : formatPrice(allowance.value)}
                        </div>
                    </div>
                ))}
                <div className="typo-line">
                    <div>
                    <p className="category">Status</p>
                    {status || 'N/A'}
                    </div>
                </div>
                <Button className="btn btn-primary bottom-btn" onClick={() => this.goToEmployeeEditForm(_id)}>Edit Employee</Button>
                </Col>
            </Row>
            <Row style={activeTab === "customPayroll" ? null : {display: "none"}}>
                { this.state.resource ?
                    <CustomValuesPayroll 
                        readOnly 
                        employee={this.state.resource} 
                        loading={this.state.loading}
                    /> : null
                }
            </Row>
            <Row style={activeTab === "governmentLoans" ? null : {display: "none"}}>
                { this.state.resource ?
                    <GovernmentLoans 
                        readOnly 
                        employee={this.state.resource} 
                        loading={this.state.loading}
                    /> : null
                }
            </Row>
            <Row style={activeTab === "leaveBalances" ? null : {display: "none"}}>
                {_id ? <LeaveBalances employeeId={_id} /> : null}
            </Row>
            </Grid>
        </div>
        );
    }
}

export default EmployeeDetails;
